import MissionCreate from './mission.create';

export default {
  create: MissionCreate,
};
